import { CancelButton, EditButton } from '@core/components/Buttons';
import { CustomExpandedPanel } from '@core/components/CustomExpandedPanel';
import { SimpleDialog, SimpleDialogContent } from '@core/components/Dialog';
import FormTitle from '@core/components/FormTitle';
import { TextLabel } from '@core/components/Inputs';
import { permissaoUtils } from '@core/util/permissaoUtil';
import { Grid, Icon, Typography } from '@material-ui/core';
import Snackbar from '@material-ui/core/Snackbar';
import Alert from '@material-ui/lab/Alert';
import { GlobalContext } from 'app/store/globalcontext';
import moment from 'moment';
import React, { useContext, useState } from 'react';
import { FaCheck, FaUser } from 'react-icons/fa';
import { usuarioModais } from '../usuarioModais';

const MOMENTOS_ACESSO = {
  QUALQUER_MOMENTO: 'A qualquer momento',
  HORARIO_COMERCIAL: 'Horário comercial, segunda-feira a sexta-feira, 08 às 18h',
  CUSTOMIZADO: 'Selecionar dia(s) e horário(s)',
};

const DIA_SEMANA_ACESSO = {
  SUNDAY: 'Domingo',
  MONDAY: 'Segunda',
  TUESDAY: 'Terça',
  WEDNESDAY: 'Quarta',
  THURSDAY: 'Quinta',
  FRIDAY: 'Sexta',
  SATURDAY: 'Sabádo',
};

const formatarDia = (dia) => {
  if (dia?.periodos?.length > 0) {
    return dia?.periodos.map((horario) => {
      return (
        <li key={horario.id} style={{ listStyle: 'none', margin: '0px 0px 10px 10px' }}>
          {formatHorario(horario)}
        </li>
      );
    });
  }
  return '';
};

const formatHorario = (horario) => {
  if (!horario?.inicio || !horario?.fim) {
    return '';
  }

  return `${horario.inicio.substring(0, 5)} - ${horario.fim.substring(0, 5)}`;
};

const VisualizarClienteModal = () => {
  const [modal, setModal] = useContext(GlobalContext).modal;
  const [usuario] = useContext(GlobalContext).usuarioAtual;
  const [open, setOpen] = React.useState(false);

  // FA-08 Fechar
  const handleCloseModal = () => {
    setModal(false);
  };

  const handleOpenEditMode = () => {
    setModal(usuarioModais.cadastroUsuario);
  };

  let periodoAcesso = '';

  if (usuario?.restricoes?.periodoAcessoInicio && usuario?.restricoes?.periodoAcessoFim) {
    periodoAcesso = `${moment(usuario?.restricoes?.periodoAcessoInicio).format('DD/MM/YYYY')} a ${moment(
      usuario?.restricoes?.periodoAcessoFim
    ).format('DD/MM/YYYY')}`;
  }

  const DadosUsuario = ({ values }) => {
    return (
      <>
        <Grid item xs={12} sm={12} md={12} lg={12} xl={12}>
          <TextLabel id="nome" label="Nome" value={values?.nome} />
        </Grid>
        <Grid item xs={12} sm={12} md={6} lg={6} xl={6}>
          <TextLabel id="email" label="E-mail" value={values?.email} />
        </Grid>
        <Grid item xs={12} sm={12} md={6} lg={6} xl={6}>
          <TextLabel id="grupoAcesso" label="Grupo de acesso" value={values?.grupoAcesso?.nome} />
        </Grid>
        {values?.vendedor && (
          <>
            <Grid
              item
              xs={12}
              sm={12}
              md={6}
              lg={6}
              xl={6}
              style={{ display: 'flex', alignItems: 'center', flexWrap: 'wrap' }}
            >
              <Icon style={{ padding: '5px', color: '#43a047' }}>
                <FaCheck size={14} />
              </Icon>
              <Typography id="vendedor">Usuário é um vendedor</Typography>
            </Grid>
            <Grid item xs={12} sm={12} md={6} lg={6} xl={6}>
              <TextLabel id="vendedor" label="Nome do vendedor" value={values?.vendedor?.pessoa?.nome} />
            </Grid>
          </>
        )}
      </>
    );
  };

  const DadosRestricoesAcesso = ({ values }) => {
    return (
      <>
        <FormTitle title="Informações para acesso" />

        <Grid container spacing={3} className="mb-8">
          {periodoAcesso ? <TextLabel id="periodoAcesso" label="Período de acesso" value={periodoAcesso} /> : ''}
          <Grid item xs={12} sm={12} md={12} lg={12} xl={12}>
            <div>
              <label htmlFor="periodoAcesso">
                <b>Em qual momento do dia o usuário poderá acessar o sistema:</b>
              </label>
              {values?.periodoHorarioAcesso && (
                <>
                  <Grid item style={{ display: 'flex', alignItems: 'center', flexWrap: 'wrap' }}>
                    <Icon style={{ padding: '5px', color: '#43a047' }}>
                      <FaCheck size={14} />
                    </Icon>
                    <Typography id="periodoAcessoValue">{MOMENTOS_ACESSO[values?.periodoHorarioAcesso]}</Typography>
                  </Grid>
                </>
              )}
            </div>
          </Grid>

          {values?.periodoHorarioAcesso === 'CUSTOMIZADO' && values?.horariosAcesso?.length && (
            <Grid item xs={12} sm={12} md={12} lg={12} xl={12}>
              <Grid item xs={12} sm={12} md={6} lg={6} xl={6}>
                {values?.horariosAcesso.map((dia) => {
                  return (
                    <TextLabel
                      id={dia?.diaDaSemana}
                      label={DIA_SEMANA_ACESSO[dia?.diaDaSemana]}
                      value={formatarDia(dia)}
                    />
                  );
                })}
              </Grid>
            </Grid>
          )}
        </Grid>

        <FormTitle title="IP's válidos para acesso" />
        <Grid container spacing={3}>
          <TextLabel id="ips" label="IP's válidos" value={values?.ips} />
        </Grid>
      </>
    );
  };

  const DadosEmpresas = ({ values }) => {
    return (
      <>
        {values
          ?.filter((empresa) => empresa.ativo)
          ?.sort((atual, prox) => atual.pessoa?.nome.localeCompare(prox.pessoa?.nome))
          ?.map((empresa) => {
            return (
              <Grid item xs={12} sm={12} md={12} lg={12} xl={12} style={{ paddingBottom: 10 }}>
                <TextLabel value={empresa?.pessoa?.nome} />
              </Grid>
            );
          })}
      </>
    );
  };

  const Content = () => {
    const [expanded, setExpanded] = useState('dadosGerais');

    const handleExpandedChange = (key, value) => {
      if (value) {
        setExpanded(key);
      } else {
        setExpanded(false);
      }
    };

    return (
      <div>
        <CustomExpandedPanel
          title="Dados gerais"
          expanded={expanded === 'dadosGerais'}
          defaultExpanded
          onChange={(_, value) => handleExpandedChange('dadosGerais', value)}
        >
          <Grid container spacing={3}>
            <DadosUsuario values={usuario} />
          </Grid>
        </CustomExpandedPanel>
        <CustomExpandedPanel
          title="Restrições de acesso"
          expanded={expanded === 'restricoes'}
          onChange={(_, value) => handleExpandedChange('restricoes', value)}
        >
          <div className="w-100">
            <DadosRestricoesAcesso values={usuario?.restricoes} />
          </div>
        </CustomExpandedPanel>
        <CustomExpandedPanel
          title="Empresas vinculadas"
          expanded={expanded === 'empresas'}
          onChange={(_, value) => handleExpandedChange('empresas', value)}
        >
          <div className="w-100">
            <DadosEmpresas values={usuario?.empresas} />
          </div>
        </CustomExpandedPanel>
      </div>
    );
  };

  const handleClose = (event, reason) => {
    if (reason === 'clickaway') {
      return;
    }

    setOpen(false);
  };

  return (
    <SimpleDialog open={modal === usuarioModais.visualizacaoUsuario} onClose={handleCloseModal}>
      <SimpleDialogContent
        header={{
          title: 'Cadastro de usuário',
          icon: <FaUser />,
          toolbar: (
            <>
              <CancelButton onClick={handleCloseModal}>Cancelar</CancelButton>
              {permissaoUtils.usuario().editar && (
                <EditButton id="add-classe-root" type="submit" onClick={handleOpenEditMode}>
                  Editar
                </EditButton>
              )}

              <Snackbar open={open} autoHideDuration={5000} onClose={handleClose}>
                <Alert
                  onClose={handleClose}
                  variant="filled"
                  severity="warning"
                  style={{ paddingTop: 15, paddingBottom: 15 }}
                  sx={{ width: '100%' }}
                >
                  Você não tem permissão para editar o cadastro do usuário. Peça autorização para o administrador.
                </Alert>
              </Snackbar>
            </>
          ),
        }}
        contentStyle={{ padding: 0 }}
        content={<Content />}
      />
    </SimpleDialog>
  );
};

export default VisualizarClienteModal;
